const FREQUENCY_OPTIONS = [
  {
    name: 'Every two weeks',
    value: 2,
  },
  {
    name: 'Every four weeks',
    value: 4,
  },
  {
    name: 'Every six weeks',
    value: 6,
  },
];

const ADD_ON_TYPE = 'add-on';

const cart = {
  decreaseQuantity: 'Decrease Quantity',
  empty: 'Your cart is empty',
  frequencyHeading: 'Ship My Subscription',
  frequencyLabel: 'My Subscription Frequency',
  increaseQuantity: 'Increase Quantity',
  subscriptionHeading: 'In My Monthly Subscription',
  todayHeading: 'Shipping today',
  trialType: 'trial',
};

export default {
  ADD_ON_TYPE,
  ENABLE_FREQUENCY: false,
  FREQUENCY_OPTIONS,
  cart,
};
